import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import * as moment from "moment";
import { useCallback, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import sleep from "sleep-promise";
import { apiCoreSave, apiODD, apiUrlGestor, SaveSpotGuarda } from "../global";
import "./forms.css";
import "./General.css";
//import IntlTelInput from 'react-intl-tel-input';
//import 'react-intl-tel-input/dist/main.css';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Form({
  Evento,
  ClCampus,
  NivelEvento,
  EventoRegistrado,
  viweForm,
  AvisoInput,
  InfoCampus,
}) {
  const [campus, setCampus] = useState(null);
  const [mustraSelects, setmustraSelects] = useState(false);
  const [mustraArea, setmustraArea] = useState(false);
  const [mustraPrograma, setmusPrograma] = useState(false);
  const [periodos, setPeriodos] = useState(null);
  const [generos, setGeneros] = useState(null);
  const [horarios, setHorarios] = useState(null);
  const [areaInteres, setAreaInteres] = useState(null);
  const [programaInteres, setProgramasInteres] = useState(null);
  const [isEnglish, setisEnglish] = useState(0); // ESTE VARIABLE SE REFIERE AL IDIOMA
  const [nombre, setNombre] = useState("");
  const [apellidoPaterno, setApellidoPaterno] = useState("");
  const [apellidoMaterno, setApellidoMaterno] = useState("");
  const [telefono, setTelefono] = useState("");
  const [fecha, setFecha] = useState("");
  const [EscuelaProveedoraS, setEscuelaProveedoraS] = useState("");
  const [sexoLegal, setsSxoLegal] = useState("");
  const [horario, setHorario] = useState("");
  const [email, setEmail] = useState("");
  // valores del padre
  const [nombreP, setNombreP] = useState("");
  const [apellidoPaternoP, setapellidoPaternoP] = useState("");
  const [apellidoMaternoP, setApellidoMaternoP] = useState("");
  const [telefonoP, setTelefonoP] = useState("");
  const [emailP, setEmailP] = useState("");
  const [infoPadre, setinfoPadre] = useState(false);
  const [comentarios, setComentarios] = useState(false);
  // valores seleccionados de cada campo
  const [campusS, setCampusS] = useState("");
  const [periodosS, setPeriodosS] = useState("");
  const [areaInteresS, setAreaInteresS] = useState("");
  const [programaInteresS, setProgramasInteresS] = useState("");
  const [aviso, setAviso] = useState(0);
  const [showForm, setShowForm] = useState(true);
  const [isBotonBloqueado, setIsBotonBloqueado] = useState(false);
  const [paises, setPaises] = useState(false);
  const [estados, setEstados] = useState(false);
  const [municipios, setMunicipios] = useState(false);
  const [escuelas, setEscuelas] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberP, setPhoneNumberP] = useState("");
  const [mustraEstado, setmustraEstado] = useState(false);
  const [mustraMunicipio, setmustraMunicipio] = useState(false);
  const [mustraEscuela, setmustraEscuela] = useState(false);
  const [mustraCampoEscuela, setmustraCampoEscuela] = useState(false);
  const [solicitarEscuela, setsolicitarEscuela] = useState(false);
  const [escuelaSend, setescuelaSend] = useState(false);
  const [formularioNoDisponible, setformularioNoDisponible] = useState(true);
  const [IniciaFormulario, setIniciaFormulario] = useState(false);
  const [statusSelect, setstatusSelect] = useState("none");
  const [mensaje, setmensaje] = useState(null)
  const [mensajeShow, setmensajeShow] = useState(false)
  const [perfil, setPerfil] = useState("")
  const [muestraOpciones, setMuestraOpciones] = useState(true)
  const [TituloFormulario, setTituloFormulario] = useState("DATOS PARA EL EVENTO DEL ESTUDIANTE INTERESADO(A)")
  const [TextoHorario, setTextoHorario] = useState("")

  const handlePhoneChange = (value, country) => {

    setPhoneNumber(value);
    setTelefono(value);
    document.getElementById("telefonoP").textContent = "";

    if (telefonoP === value)
      document.getElementById("telefonoP").textContent = "El número de teléfono del responsable legal no puede ser igual al del estudiante.";

  };

  const handlePhoneChangeP = (value, country) => {

    setPhoneNumberP(value);
    setTelefonoP(value);
    document.getElementById("telefonoPP").textContent = "";

    if (telefono === value)
      document.getElementById("telefonoPP").textContent = "El número de teléfono del responsable legal no puede ser igual al del estudiante.";

  };

  function esCorreoElectronico(texto) {
    const expresionRegular = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    //const expresionRegular = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return expresionRegular.test(texto);
  }

  const handleChangeAviso = (e) => {
    e.target.checked ? setAviso(1) : setAviso(0);
    document.getElementById("avisosP").textContent = "";
  };

  const handleChangeOpciones = (e) => {
    setPerfil(e.target.alt)
    setIniciaFormulario(true)
    setstatusSelect("none");
    console.log(e.target.value);
    console.log(e.target.checked);
    setformularioNoDisponible(false);
    setinfoPadre(false);

    /*if (e.target.value === "mayor") {
      setstatusSelect("block");
      setformularioNoDisponible(true);
    }*/

    if (comentarios) setformularioNoDisponible(false);

    if (e.target.value === "menor") setinfoPadre(true);
  };

  const handleChangePerfil = (e) => {
    setformularioNoDisponible(false);
    console.log(e.target.value);
    setinfoPadre(false);
    setComentarios(e.target.value);

    if (e.target.value === "responsable") setinfoPadre(true);
  };

  const solicitar = Evento[0].event.solicitar;

  //console.log(areaInteresS);
  //console.log(programaInteresS);

  //console.log("phone="+phoneNumber);
  /*  const url = new URL(window.location.href);
  const cValue = url.searchParams.get("c");*/

  function restaFecha(anniosRest) {
    var today = new Date();

    let annios = 1000 * 60 * 60 * 24 * 365 * anniosRest;
    let resta = today.getTime() - annios;

    let fechaNueva = new Date(resta);
    var yearN = fechaNueva.getFullYear();

    return yearN;
  }

  const handleButtonClick = () => {
    setShowForm(true);
  };
  let navigate = useNavigate();

  //const claveCampusClear = ClCampus[0].replace(/FCOE_/g, '');
  // const claveCampusClear =   ClCampus && ClCampus.length > 0 ? ClCampus.replace(/FCOE_/g, "") : "";
  const claveCampusClear = Evento[0].event.id_campus;
  //console.log("claveCampusClear=" + claveCampusClear);
  // Imformación del evento
  //console.log(Evento);
  //console.log(Evento[0].event.urlname);
  //console.log(Evento[0].event.id_campus);
  //console.log("Nivel="+Evento[0].event.nivel);

  const mandarTodo = (e) => {
    debugger;
    setIsBotonBloqueado(true);
    var fechacorregida = moment(fecha);
    if (
      nombre === "" ||
      apellidoPaterno === "" ||
      telefono === "" ||
      fecha === "" ||
      claveCampusClear === "" ||
      periodosS === "" ||
      areaInteresS === "" ||
      programaInteresS === "" ||
      sexoLegal === "" ||
      horario === "" ||
      email === "" ||
      aviso === 0 ||
      emailP === email ||
      telefonoP === telefono ||
      (solicitarEscuela === true &&
        (estados === false ||
          municipios === false ||
          escuelas === false ||
          escuelaSend === false ||
          escuelaSend === "")) ||
      (infoPadre === true &&
        (nombreP === false ||
          apellidoPaternoP === false ||
          telefonoP === false ||
          emailP === false))
    ) {
      setIsBotonBloqueado(false);
      //mostramos mensaje de que se debe de subir en los campos que no se han llenado
      if (nombre === "" || nombre.trim() === "") {
        if (isEnglish) {
          document.getElementById("nombreP").textContent = "Ingresa el nombre.";
        } else {
          document.getElementById("nombreP").textContent = "Campo Obligatorio";
        }
      }
      if (apellidoPaterno === "" || apellidoPaterno.trim() === "") {
        if (isEnglish) {
          document.getElementById("apellidoPaternoP").textContent =
            "Ingresa tu primer apellido.";
        } else {
          document.getElementById("apellidoPaternoP").textContent =
            "Campo Obligatorio";
        }
      }
      if (telefono === "" || telefono.trim() === "") {
        if (isEnglish) {
          document.getElementById("telefonoP").textContent =
            "Ingresa tu número de teléfono.";
        } else {
          document.getElementById("telefonoP").textContent =
            "Campo Obligatorio";
        }
      }
      if (fecha === "") {
        if (isEnglish) {
          document.getElementById("fechaP").textContent =
            "Ingresa tu fecha de nacimiento";
        } else {
          document.getElementById("fechaP").textContent = "Campo Obligatorio";
        }
      }

      if (sexoLegal === "" || sexoLegal.trim() === "")
        document.getElementById("sexoP").textContent =
          "Debes seleccionar tu sexo para continuar";

      if (email === "" || email.trim() === "") {
        document.getElementById("correoEstP").textContent =
          "Ingresa un correo electrónico para continuar";
      } else if (!esCorreoElectronico(email)) {
        document.getElementById("correoEstP").textContent =
          "Ingresa un correo electrónico válido";
      }
      else {
        document.getElementById("correoEstP").textContent = ""
      }

      if (horario === "" || horario.trim() === "")
        document.getElementById("horarioP").textContent =
          "Debes seleccionar un horario preferido para continuar";

      if (campusS === "") {
        if (isEnglish) {
          document.getElementById("campusP").textContent =
            "Selecciona un campus.";
        } else {
          document.getElementById("campusP").textContent = "Campo Obligatorio";
        }
      }
      if (periodosS === "") {
        if (isEnglish) {
          document.getElementById("periodoP").textContent =
            "Selecciona una fecha esperada de ingreso.";
        } else {
          document.getElementById("periodoP").textContent = "Campo Obligatorio";
        }
      }
      if (mustraSelects) {
        if (areaInteresS === "") {
          if (isEnglish) {
            document.getElementById("areaP").textContent =
              "Debes seleccionar una entrada de interés para continuar.";
          } else {
            document.getElementById("areaP").textContent = "Campo Obligatorio";
          }
        }
        if (programaInteresS === "") {
          if (isEnglish) {
            document.getElementById("programaP").textContent =
              "Debes seleccionar una carrera de interés para continuar";
          } else {
            document.getElementById("programaP").textContent =
              "Campo Obligatorio";
          }
        }
      }
      if (aviso === 0) {
        if (isEnglish) {
          document.getElementById("avisosP").textContent =
            "El campo es requerido";
        } else {
          document.getElementById("avisosP").textContent = "Campo Obligatorio";
        }
      }

      if (solicitarEscuela) {
        if (estados === false)
          document.getElementById("paisP").textContent =
            "Selecciona un país para continuar.";

        if (municipios === false && estados !== false)
          document.getElementById("estadoP").textContent =
            "Selecciona un estado para continuar.";

        if (
          escuelas === false &&
          mustraCampoEscuela === false &&
          municipios !== false
        )
          document.getElementById("municipioP").textContent =
            "Selecciona una ciudad para continuar.";

        if (
          escuelas !== false &&
          mustraCampoEscuela === false &&
          (escuelaSend === false || escuelaSend === "0")
        )
          document.getElementById("escuelaP").textContent =
            "Selecciona una escuela.";

        if (
          mustraCampoEscuela === true &&
          (escuelaSend === false || escuelaSend === "")
        )
          document.getElementById("escuelaIP").textContent =
            "Ingresa el nombre de una escuela.";
      }
      if (infoPadre) {
        if (nombreP === false || nombreP.trim() === "")
          document.getElementById("nombrePP").textContent =
            "Ingresa el nombre del responsable legal.";

        if (apellidoPaternoP === false || apellidoPaternoP.trim() === "")
          document.getElementById("apellidoPaternoPP").textContent =
            "Ingresa el primer apellido del responsable legal.";

        if (telefonoP === false || telefonoP.trim() === "")
          document.getElementById("telefonoPP").textContent =
            "Ingresa el número de teléfono del responsable legal.";

        if (emailP === false || emailP.trim() === "") {
          document.getElementById("emailPP").textContent =
            "Ingresa un correo electrónico para continuar";
        } else if (!esCorreoElectronico(emailP)) {
          document.getElementById("emailPP").textContent =
            "Ingresa un correo electrónico válido";
        }

        if (emailP === email) {
          document.getElementById("emailPP").textContent = "El correo del responsable legal no puede ser igual al del estudiante."
          document.getElementById("correoEstP").textContent = "El correo del responsable legal no puede ser igual al del estudiante."
          // setIsBotonBloqueado(true);
        }


        if (telefonoP === telefono) {
          document.getElementById("telefonoP").textContent = "El número de teléfono del responsable legal no puede ser igual al del estudiante.";
          document.getElementById("telefonoPP").textContent = "El número de teléfono del responsable legal no puede ser igual al del estudiante.";
          // setIsBotonBloqueado(true);
        }


      }
    } else {
      //localStorage.setItem('paisID', JSON.parse(paisS).key)
      const cmpaInput = document.getElementById("cmpaForm");
      const cmpaValue = cmpaInput.value.replace(/CMPA-/g, "");

      const eventoInput = document.getElementById("eventoForm");
      const eventoValue = eventoInput.value.replace(/EVE-/g, "");

      const contextoForm = document.getElementById("contextoForm");
      const concetxtoValue = contextoForm.value;

      const nivelInput = document.getElementById("nivelForm");
      const NivelValue = nivelInput.value;

      const idLandingInput = document.getElementById("idLanding");
      const idLandingValue = idLandingInput.value;
      console.log(idLandingValue);

      const utm_termInput = document.getElementById("utm_term");
      const utm_termValue = utm_termInput.value;
      console.log(utm_termValue);

      const referInput = document.getElementById("refer");
      const referValue = referInput.value;

      const landingFormInput = document.getElementById("landingForm");
      const landingFormValue = landingFormInput.value;

      const nombreRegistroVal = landingFormValue; //"Eventos " + concetxtoValue; //Eventos Guadalajara

      const utm_crm_campaign_input = localStorage.getItem(
        "utm_crm_campaign_Local"
      );
      const campusId = Evento[0].event.id_campus;
      const escuela = Evento[0].event.escuela;

      let CampusKey = "";
      if (campusId === "VC") {
        if (localStorage.getItem("campusStorage")) {
          CampusKey = localStorage.getItem("campusStorage");
        } else CampusKey = "A";
      } else CampusKey = campusId;

      var cmpaSend = cmpaValue;
      if (cmpaSend === "" || cmpaSend === null)
        cmpaSend = InfoCampus[0].campana;

      let grandoSend = "profesional";
      if (NivelValue === "03") grandoSend = "prepatec";

      // console.error("test");
      const urlParams = new URLSearchParams(window.location.search);
      const utm_medium_send = urlParams.get("utm_medium");
      const utm_source_send = urlParams.get("utm_source");
      const utm_term_send = urlParams.get("utm_term");
      const utm_content_send = urlParams.get("utm_content");
      const utm_campaign_send = urlParams.get("utm_campaign");
      const utm_cmpa_send = urlParams.get("utm_cmpa");
      const utm_origen_send = urlParams.get("utm_origen");

      const utm_cmpaInput = document.getElementById("utm_cmpa");
      const utm_cmpaValue = utm_cmpa_send || (utm_cmpaInput ? utm_cmpaInput.value : "");
      console.log(utm_cmpaValue);

      debugger;
      const credentials = {
        name: nombre,
        lastName: apellidoPaterno,
        secondLastName: apellidoMaterno,
        celularPhone: telefono,
        email: email,
        birthDate: fechacorregida.format("DD/MM/YYYY"),
        escuelasprov: EscuelaProveedoraS, //JSON.parse(paisS).key,  //JSON.pase(paisS).nombre   <- Para enviar el nombre y no el ID
        sede: CampusKey,
        period: JSON.parse(periodosS).key,
        area: JSON.parse(areaInteresS).key,
        program: JSON.parse(programaInteresS).key,
        avisos: aviso,
        cmpa: cmpaSend,
        event: eventoValue,
        contexto: concetxtoValue,
        grade: grandoSend,
        landingUrl:
          "https://calendario.tec.mx/evento/" + Evento[0].event.urlname,
        formName: Evento[0].event.id_evento + Evento[0].event.urlname,
        landing: nombreRegistroVal,
        utmTerm: utm_term_send,
        utmMedium: utm_medium_send,
        utmSource: utm_source_send,
        utmContent: utm_content_send,
        utmCampaign: utm_campaign_send,
        utmCrmCampaign: utm_crm_campaign_input,
        utmCmpa: utm_cmpaValue,
        refer: referValue,
        schoolKey: escuela,
        gender: JSON.parse(sexoLegal).nombre,
        preferredAtentionTime: JSON.parse(horario).nombre,
        //ENVIAR A hubspot
        sendhubspot: "true",
        sendsalesforce: "true",
        SaveSpotServer: SaveSpotGuarda,
        //Datos del responsable legal
        papa: {
          email: emailP,
          formName: Evento[0].event.id_evento + Evento[0].event.urlname,
          landingUrl:
            "https://calendario.tec.mx/evento/" + Evento[0].event.urlname,
          name: nombreP,
          lastName: apellidoPaternoP,
          secondLastName: apellidoMaternoP,
          celularPhone: telefonoP,
          cmpa: cmpaSend,
        },
        sendMixto: "true",
        extraFields: { "perfil": perfil },
        description: 'nombrePadre: ' + nombreP + ', apellidoPadre1: ' + apellidoPaternoP + ', apellidoPadre2: ' + apellidoMaternoP + ', telefonoPadre: ' + telefonoP + ', emailPadre: ' + emailP,
      };

      if (!escuela) delete credentials.schoolKey;

      if (!eventoValue) delete credentials.utmTerm;

      if (!utm_cmpaValue || utm_cmpaValue === "") delete credentials.utmCmpa;

      if (escuelaSend) {
        credentials.schoolKey = escuelaSend;
        credentials.schoolAdicional = mustraCampoEscuela;
      }

      if (!infoPadre) {
        delete credentials.papa;
        delete credentials.sendMixto;
        delete credentials.description;
      }

      if (utm_origen_send) {
        if (utm_origen_send === "mkt")
          credentials.prospectOrigin = "Marketing Digital";
        else credentials.prospectOrigin = utm_origen_send;
      }

      //console.log(credentials);
      //console.log(JSON.stringify(credentials))

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // mode: 'no-cors', // Establecer el modo no-cors
        body: JSON.stringify(credentials),
      };
      //console.log(options);

      fetch(apiUrlGestor + "enviaRegistro.php", options)
        .then((response) => response.json())
        .then(sleep(2000))
        .then((data) => {
          // Manipular los datos de la respuesta
          console.log(data);

          // alert("se envió con exito");
          localStorage.removeItem("utm_term_Local");
          localStorage.removeItem("utm_medium_Local");
          localStorage.removeItem("utm_source_Local");
          localStorage.removeItem("utm_content_Local");
          localStorage.removeItem("utm_campaign_Local");
          localStorage.removeItem("utm_crm_campaign_Local");
          localStorage.removeItem("expiracion");
          setIsBotonBloqueado(false);
          viweForm(null);
          navigate(
            "../evento/" + Evento[0].event.urlname + "/gracias?g=1#confirmacion"
          );
        })
        .catch((error) => {
          console.log(error);
          setIsBotonBloqueado(false);
        });
      //localStorage.setItem('correo', correo)
    }

    e.preventDefault();
    EventoRegistrado();
    //navigate("../evento/" + Evento[0].event.urlname + "/gracias#confirmacions");
  };

  // =================== SEXO LEGAL ======================
  const consultaSexoLegal = useCallback(() => {
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(apiODD + "api/v1/genders", options)
      .then((response) => response.json())
      .then((datos) => {
        //console.log("genders",datos);
        setGeneros(datos["gender"]);
      });
  }, []);


  // =================== MENSAJE DE OFERTA ======================
  const consultaMensaje = useCallback(() => {
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(apiODD + "api/v1/messages/outdated-period", options)
      .then((response) => response.json())
      .then((datos) => {
        //console.log(datos.messages.message)
        setmensaje(datos.messages.message)
      });
  }, []);

  // =================== MENSAJE DE TITULO ======================
  const consultaMensajeHorario = useCallback((slug) => {
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(apiODD + "api/v1/messages/" + slug, options)
      .then((response) => response.json())
      .then((datos) => {
        //console.log(datos.messages.message)
        setTextoHorario(datos.messages.message)
      });
  }, []);

  // =================== Horario preferido de atención ======================
  const consultaHorarioPreferido = useCallback(() => {
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(apiODD + "api/v1/atentionTime", options)
      .then((response) => response.json())
      .then((datos) => {
        setHorarios(datos["preferredAtentionTime"]);
      });
  }, []);

  // =================== CAMPUS ======================
  const consultaCampus = useCallback(() => {
    var detailsCampus = {
      valor: "05",
    };
    var formBody = [];
    for (var property in detailsCampus) {
      var encodeKey = encodeURIComponent(property);
      var encodeValue = encodeURIComponent(detailsCampus[property]);
      formBody.push(encodeKey + "=" + encodeValue);
    }
    formBody = formBody.join("&");
    fetch(apiCoreSave + "/campus_internacional.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: formBody,
    })
      .then((resp) => {
        return resp.json();
      })
      .then((json) => {
        //console.log(json)
        setCampus(json);
      });
  }, []);

  // =================== PERIODOS ======================
  const consultaPeriodos = useCallback(() => {
    let campusx;
    try {
      campusx = claveCampusClear;
    } catch (error) {
      campusx = "";
    }

    var data = {
      include: { offerings: true },
      filters: {
        campus: { soadKey: campusx },
        grade: { soadKey: NivelEvento },
      },
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), // Convertir datos a JSON
    };

    fetch(apiODD + "api/v1/campuses/search-active-offering", options)
      .then((response) => response.json())
      .then((datos) => {
        //console.log(datos['campuses'][0]['offerings']);
        setPeriodos(datos["campuses"][0]["offerings"]);
      });
  }, [claveCampusClear, NivelEvento]);

  const consultaPaises = useCallback(() => {
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(apiODD + "api/v1/paises", options)
      .then((response) => response.json())
      .then((datos) => {
        console.log(datos);
        setPaises(datos["countries"]);
      });
  }, []);

  // =================== AREA ======================
  const consultaAreaInteres = useCallback(
    (claveCampusClear, periodoS, NivelEvento) => {
      let campus, periodo;

      try {
        campus = Evento[0].event.id_campus;
        periodo = JSON.parse(periodoS).key;
      } catch (error) {
        campus = "";
        periodo = "";
      }

      var data = {
        filters: {
          campus: {
            soadKey: campus,
          },
          period: {
            soadKey: periodo,
          },
          grade: {
            soadKey: Evento[0].event.nivel,
          },
        },
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data), // Convertir datos a JSON
      };

      fetch(apiODD + "api/v1/areas/search-active-offering", options)
        .then((response) => response.json())
        .then((datos) => {
          // console.log(datos['areas']);
          setAreaInteres(datos["areas"]);
        });
    },
    [Evento]
  );

  // =================== PROGRAMA ======================
  const consultaPrograma = useCallback(
    (claveCampusClear, periodoS, areaS, NivelEvento) => {
      let campus, periodo, area;
      try {
        campus = Evento[0].event.id_campus;
        periodo = JSON.parse(periodoS).key;
        area = JSON.parse(areaS).key;
      } catch (error) {
        campus = "";
        periodo = "";
        area = "";
      }

      var data = {
        filters: {
          campus: {
            soadKey: campus,
          },
          period: {
            soadKey: periodo,
          },
          grade: {
            soadKey: Evento[0].event.nivel,
          },
          area: {
            soadKey: area,
          },
        },
      };

      if (Evento[0].event.nivel === "03") delete data.filters.area;

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data), // Convertir datos a JSON
      };

      fetch(apiODD + "api/v1/programs/search-active-offering", options)
        .then((response) => response.json())
        .then((datos) => {
          // console.log(datos['programs']);
          setProgramasInteres(datos["programs"]);
        });
    },
    [Evento]
  );

  //============================ DATA ==================================================

  const handleChange = (e) => {
    //debugger
    setIsBotonBloqueado(false);
    if (e.target.name === "nombre") {
      setNombre(e.target.value);
    } else if (e.target.name === "apellidoPaterno") {
      setApellidoPaterno(e.target.value);
    } else if (e.target.name === "apellidoMaterno") {
      setApellidoMaterno(e.target.value);
    } else if (e.target.name === "fecha") {
      setFecha(e.target.value);
    } else if (e.target.name === "EscuelaProveedora") {
      setEscuelaProveedoraS(e.target.value);
    } else if (e.target.name === "sexo") {
      setsSxoLegal(e.target.value);
    } else if (e.target.name === "horario") {
      setHorario(e.target.value);
    } else if (e.target.name === "correo") {
      setEmail(e.target.value);
      if (e.target.value !== "" || e.target.value.trim() !== "") {
        document.getElementById("correoEstP").textContent = ""
      }

      //Validamos que no sea igual que el del padre
      if (emailP === e.target.value) {
        document.getElementById("correoEstP").textContent = "El correo del responsable legal no puede ser igual al del estudiante."
      }
      else
        document.getElementById("correoEstP").textContent = ""


    } else if (e.target.name === "nombreP") {
      setNombreP(e.target.value);
    } else if (e.target.name === "apellidoPaternoP") {
      setapellidoPaternoP(e.target.value);
    } else if (e.target.name === "apellidoMaternoP") {
      setApellidoMaternoP(e.target.value);
    } else if (e.target.name === "telefonoP") {
      setTelefonoP(e.target.value);
    } else if (e.target.name === "emailP") {
      setEmailP(e.target.value);

      //Validamos que no sea igual que el del padre
      if (email === e.target.value) {
        document.getElementById("emailPP").textContent = "El correo del responsable legal no puede ser igual al del estudiante."
        return

      }


    } else if (e.target.name === "campus") {
      setCampusS(e.target.value);
      setPeriodos(null);
      setAreaInteres(null);
      setProgramasInteres(null);
      setPeriodosS("");
      setAreaInteresS("");
      setProgramasInteresS("");
      consultaPeriodos(e.target.value);
    } else if (e.target.name === "periodo") {
      setmustraSelects(true);
      const myJSON = e.target.value;
      const myObj = JSON.parse(myJSON);
      //console.log(myObj.key);

      if (myObj.oferta)
        setmensajeShow(true)
      else
        setmensajeShow(false)

      if (myObj.key === "otro") {
        setPeriodosS('{"periodo":"otro","key":"otro"}');
        //document.getElementById("area").style.display = "none";
        setmustraArea(false);
        //document.getElementById("programa").style.display = "none";
        setmusPrograma(false);
        setAreaInteresS('{"nombre":"otro","key":"otro"}');
        setProgramasInteresS('{"nombre":"otro","key":"otro"}');
      } else {
        setPeriodosS(e.target.value);
        if (NivelEvento === "03") {
          var area = '{"nombre":"Prepa","key":"046"}';
          setAreaInteresS(area);
          //document.getElementById("area").style.display = "none";
          setmustraArea(false);
          //document.getElementById("programa").style.display = "block";
          setmusPrograma(true);
          //consultaPrograma(claveCampusClear, e.target.value, area, NivelEvento);
          setmusPrograma(true);
        } else {
          //document.getElementById("area").style.display = "block";
          setmustraArea(true);
          //document.getElementById("programa").style.display = "block";
          setmusPrograma(true);

          setAreaInteres(null);
          setProgramasInteres(null);
          setAreaInteresS("");
          setProgramasInteresS("");
          consultaAreaInteres(campusS, e.target.value);
        } //END ELSE
      }
    } else if (e.target.name === "area") {
      setAreaInteresS(e.target.value);
      setProgramasInteres(null);
      setProgramasInteresS("");
      consultaPrograma(campusS, periodosS, e.target.value);
    } else if (e.target.name === "programa") {
      setProgramasInteresS(e.target.value);
    } else if (e.target.name === "avisos") {
      e.target.checked ? setAviso(1) : setAviso(0);
    } else {
      console.log("ERROR id no encontrado");
    }

    if (e.target.name === "avisos" && !e.target.checked) {
      document.getElementById(e.target.name + "P").textContent =
        "Este campo es requerido";
    } else {
      console.log(e.target.name);
      document.getElementById(e.target.name + "P").textContent = "";
    }
  };

  const handleChangeEsc = (e) => {
    try {
      var obj = JSON.parse(e.target.value);
    } catch (error) {
      console.log("error = " + error);
    }

    //console.log(e.target.value)

    /* console.log(e.target.id)
      console.log(e.target.value)
      console.log(obj);         // { nombre: 'México', key: 1 }
      console.log(obj.nombre);  // "México"
      console.log(obj.key);     // 1*/

    if (e.target.name === "pais") {
      localStorage.setItem(e.target.name, obj.nombre);
      setmustraEstado(false);
      setmustraMunicipio(false);
      setmustraEscuela(false);
      setmustraCampoEscuela(false);

      const options = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      fetch(apiODD + "api/v1/states/" + obj.key, options)
        .then((response) => response.json())
        .then((datos) => {
          //console.log(datos["states"]);
          setEstados(datos["states"]);
          if (datos["states"].length > 0) {
            setmustraEstado(true);
            document.getElementById("paisP").textContent = "";
          }
        });
    }

    if (e.target.name === "estado") {
      localStorage.setItem(e.target.name, obj.nombre);
      setmustraMunicipio(false);
      setmustraEscuela(false);
      setmustraCampoEscuela(false);

      const options = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      fetch(apiODD + "api/v1/municipalities/" + obj.key, options)
        .then((response) => response.json())
        .then((datos) => {
          //console.log(datos["municipalities"]);
          setMunicipios(datos["municipalities"]);
          if (datos["municipalities"].length > 0) {
            setmustraMunicipio(true);
            document.getElementById("estadoP").textContent = "";
          } else setmustraCampoEscuela(true);
        });
    }

    if (e.target.name === "municipio") {
      localStorage.setItem(e.target.name, obj.nombre);
      var nivel = "Preparatoria";
      if (Evento[0].event.nivel === "03") nivel = "Secundaria";

      setmustraEscuela(false);
      setmustraCampoEscuela(false);

      var data = {
        id_municipality: obj.key,
        tipo: nivel,
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      fetch(apiODD + "api/v1/schools/linked_schools", options)
        .then((response) => response.json())
        .then((datos) => {
          //console.log(datos);
          setEscuelas(datos);
          if (datos.length > 0) {
            setmustraEscuela(true);
            document.getElementById("municipioP").textContent = "";
          } else setmustraCampoEscuela(true);
        });
    }

    if (e.target.name === "escuelas") {
      localStorage.setItem(e.target.name, obj.nombre);
      setescuelaSend(false);
      setmustraCampoEscuela(false);
      document.getElementById("escuelaP").textContent = "";
      setescuelaSend(obj.key);

      if (obj.key === "otro") {
        setmustraCampoEscuela(true);
        setescuelaSend(false);
      }
    }

    if (e.target.name === "escuela") {
      document.getElementById("escuelaIP").textContent = "";

      let paisStorage = "País:" + localStorage.getItem("pais") + " | ";
      let estadoStorage = "Estado:" + localStorage.getItem("estado") + " | ";
      let municipioStorage =
        "Ciudad:" + localStorage.getItem("municipio") + " | ";

      setescuelaSend(
        paisStorage +
        estadoStorage +
        municipioStorage +
        "Escuela:" +
        e.target.value
      );
      localStorage.setItem(
        "escuelas",
        paisStorage +
        estadoStorage +
        municipioStorage +
        "Escuela:" +
        e.target.value
      );
    }
  };

  useEffect(() => {
    // SE INICIA LA CONFIGURACIÓN INCIAL DEL FORMULARIO
    consultaSexoLegal();
    consultaMensajeHorario("descripcion-horario")
    consultaHorarioPreferido();
    consultaPeriodos(claveCampusClear);
    consultaMensaje()

    if (NivelEvento === "03") {
      setIniciaFormulario(true)
      setPerfil("Soy estudiante menor de 18 años")
      setstatusSelect("none");
      setformularioNoDisponible(false);
      setinfoPadre(true);
      setMuestraOpciones(false)
    }


    if (solicitar === 1) {
      consultaPaises();
      setsolicitarEscuela(true);
    }

    // debemos checar la selección

    if (claveCampusClear !== "" && periodosS !== "") {
      consultaAreaInteres(claveCampusClear, periodosS, NivelEvento);
    }
    if (claveCampusClear !== "" && periodosS !== "" && areaInteresS !== "") {
      consultaPrograma(claveCampusClear, periodosS, areaInteresS, NivelEvento);
    }

    const tipoEvento = Evento[0].event.tipo_evento;
    console.log("tipoEvento", tipoEvento);

    switch (tipoEvento) {
      case '902106':
      case '902105':
        setTituloFormulario("DATOS DEL ESTUDIANTE INTERESADO(A)")
        //setTextoHorario("Brindaremos acompañamiento en el proceso de admisión según el horario indicado.")
        consultaMensajeHorario("subtexto-horario")
        break;

      default:
        break;
    }

  }, [
    isEnglish,
    claveCampusClear,
    consultaCampus,
    consultaPeriodos,
    consultaAreaInteres,
    consultaPrograma,
    periodosS,
    areaInteresS,
    NivelEvento,
    solicitar,
    consultaPaises,
    consultaSexoLegal,
    consultaHorarioPreferido,
    consultaMensaje,
    consultaMensajeHorario,
    Evento
  ]);

  useEffect(() => {
    // este solo se debe ejecutar una vez
    if (localStorage.getItem("ingles") == null) {
      localStorage.setItem("ingles", 0); // si no hay una opción seleccionada lo pongo en español
    }
    setisEnglish(localStorage.getItem("ingles"));
  }, []);

  var campusNameInput;

  //  console.log(InfoCampus[0].name)
  // console.log(Evento[0].event.campuses.length)

  if (
    Evento[0].event.campuses.length > 1 &&
    localStorage.getItem("campusStorageName")
  )
    campusNameInput = localStorage.getItem("campusStorageName");
  else {
    if (InfoCampus[0].name) campusNameInput = InfoCampus[0].name;
    else {
      if (localStorage.getItem("campusStorageName"))
        campusNameInput = localStorage.getItem("campusStorageName");
    }
  }

  switch (campusNameInput) {
    case "Ciudad de México":
      campusNameInput = "cdmx";
      break;

    case "Ciudad Juárez":
      campusNameInput = "ciudad-juarez";
      break;

    case "Ciudad Obregón":
      campusNameInput = "ciudad-obregon";
      break;

    case "Estado de México":
      campusNameInput = "estado-de-mexico";
      break;

    case "León":
      campusNameInput = "leon";
      break;

    case "Querétaro":
      campusNameInput = "queretaro";
      break;

    case "San Luis Potosí":
      campusNameInput = "san-luis-potosi";
      break;

    case "Santa Fe":
      campusNameInput = "santa-fe";
      break;

    case "Eugenio Garza Lagüera":
      campusNameInput = "prepatec-monterrey";
      break;

    case "Eugenio Garza Sada":
      campusNameInput = "prepatec-monterrey";
      break;

    case "prepatec-guadalajara":
      campusNameInput = "Santa Anita";
      break;

    case "Santa Catarina":
      campusNameInput = "prepatec-monterrey";
      break;

    case "Sonora Norte":
      campusNameInput = "prepatec-sonora-norte";
      break;

    case "Valle Alto":
      campusNameInput = "prepatec-monterrey";
      break;

    case "Cumbres":
      campusNameInput = "prepatec-monterrey";
      break;

    case "Esmeralda":
      campusNameInput = "prepatec-cdmx";
      break;

    default:
      //console.log("");
      break;
  } //switch

  campusNameInput = campusNameInput.toLowerCase();

  //console.log("campusName=" + campusNameInput);

  const utm_source_input = localStorage.getItem("utm_source_Local");
  const utm_medium_input = localStorage.getItem("utm_medium_Local");
  const utm_term_input = localStorage.getItem("attr_tec_term");
  const utm_cmpa_input = localStorage.getItem("utm_cmpa_Local");

  return (
    <>
      <Grid spacing={2}>
        <div id="formluario" className="formsReg">
          <div className="textoarribaRegistro"></div>
          <div className="row m-0 p-0" style={{ justifyContent: "center" }}>
            <div className="contform col-md-8 col-xs-12">
              {showForm && (
                <form onSubmit={mandarTodo}>
                  <div id="hiddens">
                    {Evento.map((eventos) => (
                      <>
                        <input
                          type="hidden"
                          id="nombreRegistro"
                          name="nombreRegistro"
                          value={`Evento ${eventos.event.id_evento}`}
                        />

                        <input
                          type="hidden"
                          name="landing"
                          id="landingForm"
                          value={`Evento-${eventos.event.id_evento}`}
                        />
                        <input
                          type="hidden"
                          name="origenDestino"
                          id="origenDestinoForm"
                          value="Profesional de Preparatoria No Tec"
                        />
                        <input
                          type="hidden"
                          name="retURL"
                          value="https://admision.tec.mx/uat/profeareayprogramatec21/prod_test/savespot_profe_pruebas_todos?gracias=gracias#contact"
                        />
                        <input
                          type="hidden"
                          name="refer"
                          id="refer"
                          value={`https://calendario.tec.mx/evento/${eventos.event.urlname}`}
                        />
                        <input
                          type="hidden"
                          name="cmpa"
                          id="cmpaForm"
                          value={eventos.event.cmpa}
                        />
                        <input
                          type="hidden"
                          name="evento"
                          id="eventoForm"
                          value={eventos.event.fonteva}
                        />
                        <input
                          type="hidden"
                          name="utm_term"
                          id="utm_term"
                          value={utm_term_input}
                        />
                        <input
                          type="hidden"
                          name="utm_cmpa"
                          id="utm_cmpa"
                          value={utm_cmpa_input || ""}
                        />
                        <input
                          type="hidden"
                          name="contexto"
                          id="contextoForm"
                          value={`${campusNameInput}`}
                        />
                        <input
                          type="hidden"
                          name="contextoInit"
                          id="contextoFormInit"
                          value={`${campusNameInput}`}
                        />
                        <input
                          type="hidden"
                          name="nivel"
                          id="nivelForm"
                          value={eventos.event.nivel}
                        />
                        <input type="hidden" name="flag" id="flag" value="1" />
                        <input
                          type="hidden"
                          name="idLanding"
                          id="idLanding"
                          value="201"
                        />
                        <input
                          type="hidden"
                          name="utm_source"
                          id="utm_source"
                          value={utm_source_input}
                        />
                        <input
                          type="hidden"
                          name="utm_medium"
                          id="utm_medium"
                          value={utm_medium_input}
                        />
                      </>
                    ))}
                  </div>

                  {muestraOpciones && (
                    <>
                      <div className="form-group" id="select">
                        <label className="checkbox-inline" htmlFor="opcion1">
                          <input
                            type="radio"
                            id="opcion1"
                            name="opcion"
                            value="mayor"
                            alt="Soy estudiante mayor de 18 años"
                            onChange={handleChangeOpciones}
                          />{" "}
                          Soy estudiante mayor de 18 años
                        </label>
                      </div>

                      <div className="form-group" id="select">
                        <label className="checkbox-inline" htmlFor="opcion2">
                          <input
                            type="radio"
                            id="opcion2"
                            value="menor"
                            name="opcion"
                            alt="Soy estudiante menor de 18 años"
                            onChange={handleChangeOpciones}
                          />{" "}
                          Soy estudiante menor de 18 años
                        </label>
                      </div>

                      <div className="form-group" id="select">
                        <label className="checkbox-inline" htmlFor="opcion3">
                          <input
                            type="radio"
                            id="opcion3"
                            value="menor"
                            name="opcion"
                            alt="Soy responsable legal de un estudiante"
                            onChange={handleChangeOpciones}
                          />{" "}
                          Soy responsable legal de un estudiante
                        </label>
                      </div>
                      <br></br>
                    </>
                  )}

                  <div
                    className="form-group"
                    id="select"
                    style={{ display: statusSelect }}
                  >
                    <TextField
                      select
                      style={{ appearance: "auto" }}
                      id="perfil"
                      name="perfil"
                      data-value=""
                      className="form-control"
                      aria-required="true"
                      label="¿Cuál perfil te describe mejor?"
                      onChange={handleChangePerfil}
                    >
                      <MenuItem value="estudianteTec">
                        Soy estudiante interesado en ingresar al Tec
                      </MenuItem>
                      <MenuItem value="responsable">Responsable legal</MenuItem>
                    </TextField>
                    <br></br>
                  </div>
                  <br></br>

                  {IniciaFormulario && (
                    <div>

                      <h6>{TituloFormulario}</h6><br></br>
                      <div className="preg">
                        <TextField
                          disabled={formularioNoDisponible}
                          type="text"
                          name="nombre"
                          variant="standard"
                          label="Nombre(s) del estudiante interesado"
                          className="form-control effect-10"
                          id="nombre"
                          onChange={handleChange}
                        />
                        <span class="focus-bg"></span>
                        <p className="errorForm" id="nombreP"></p>
                      </div>
                      <div className="preg">
                        <TextField
                          disabled={formularioNoDisponible}
                          type="text"
                          name="apellidoPaterno"
                          label="Primer apellido"
                          className="form-control"
                          id="apellidoPaterno"
                          variant="standard"
                          onChange={handleChange}
                        />
                        <p className="errorForm" id="apellidoPaternoP"></p>
                      </div>
                      <div className="preg">
                        <TextField
                          variant="standard"
                          name="apellidoMaterno"
                          disabled={formularioNoDisponible}
                          type="text"
                          label="Segundo apellido (opcional)"
                          className="form-control"
                          id="apellidoMaterno"
                          onChange={handleChange}
                        />
                        <p className="errorForm" id="apellidoMaternoP"></p>
                      </div>

                      <div className="preg">
                        <TextField
                          name="correo"
                          variant="standard"
                          disabled={formularioNoDisponible}
                          type="text"
                          label="Correo electrónico del estudiante"
                          className="form-control effect-10"
                          id="email"
                          onChange={handleChange}
                        />
                        <p id="correoMsg">
                          Si ya te has registrado previamente, por favor usa el
                          mismo correo.
                        </p>
                        <p className="errorForm" id="correoEstP"></p>
                        {/* LABEL: */}
                      </div>

                      <div className="preg">
                        <label htmlFor="telefono">
                          Celular del estudiante interesado
                        </label>
                        <PhoneInput
                          disabled={formularioNoDisponible}
                          inputProps={{
                            name: "telefono",
                            required: true,
                          }}
                          inputExtraProps={{
                            className: "form-control", // Agrega tu clase personalizada aquí
                          }}
                          inputStyle={{
                            border: "none",
                            borderBottom: "1px solid #949494",
                            width: "100%",
                            borderRadius: "0px",
                          }}
                          country={"mx"}
                          value={phoneNumber}
                          onChange={handlePhoneChange}
                          placeholder="Celular del estudiante interesado"
                        />
                        <p className="errorForm" id="telefonoP"></p>
                      </div>

                      <div className="FechaPadre">
                        <div className="Fecha">
                          <label htmlFor="fecha">
                            Fecha de nacimiento (dd/mm/aaaa):
                          </label>
                        </div>
                        {/* 24/09/2002 <- FORMATO CORRECTO  data-date-format='DD MMM YYYY'  */}
                        <div className="funfecha">
                          <TextField
                            variant="standard"
                            disabled={formularioNoDisponible}
                            type="date"
                            id="fecha"
                            name="fecha"
                            className="form-control"
                            data-date=""
                            data-date-format="DD MMMM YYYY"
                            onChange={handleChange}
                            min={restaFecha(40) + "-01-01"}
                            max={restaFecha(11) + "-12-31"}
                          />
                          <p className="errorForm" id="fechaP"></p>
                        </div>
                      </div>

                      <div className="form-group" id="select">
                        <TextField
                          style={{ appearance: "auto" }}
                          id="sexo"
                          select
                          label="Sexo"
                          disabled={formularioNoDisponible}
                          name="sexo"
                          data-value=""
                          className="form-control"
                          aria-required="true"
                          onChange={handleChange}
                        >
                          {generos &&
                            generos.map(({ id, value, name }) => (
                              <MenuItem
                                key={id}
                                value={JSON.stringify({
                                  nombre: value,
                                  key: id,
                                })}
                              >
                                {name}
                              </MenuItem>
                            ))}
                        </TextField>
                        <p className="errorForm" id="sexoP"></p>
                      </div>




                      {solicitar === 1 && (
                        <div className="form-group" id="select">
                          <br></br>

                          <h6>SELECCIONA TU ESCUELA DE PROCEDENCIA</h6>
                          <TextField
                            select
                            style={{ appearance: "auto" }}
                            id="pais"
                            name="pais"
                            label="Selecciona un país para buscar un estado"
                            data-value=""
                            className="form-control"
                            aria-required="true"
                            disabled={formularioNoDisponible}
                            onChange={handleChangeEsc}
                          >
                            {paises &&
                              paises.map(({ id, name }) => (
                                <MenuItem
                                  value={JSON.stringify({
                                    nombre: name,
                                    key: id,
                                  })}
                                >
                                  {name}
                                </MenuItem>
                              ))}
                          </TextField>
                          <p className="errorForm" id="paisP"></p>

                          {mustraEstado && (
                            <div className="form-group" id="select">
                              <TextField
                                select
                                style={{ appearance: "auto" }}
                                id="estado"
                                name="estado"
                                label="Selecciona un estado para buscar una ciudad"
                                data-value=""
                                className="form-control"
                                aria-required="true"
                                onChange={handleChangeEsc}
                              >
                                {estados &&
                                  estados.map(({ id, name }) => (
                                    <MenuItem
                                      value={JSON.stringify({
                                        nombre: name,
                                        key: id,
                                      })}
                                    >
                                      {name}
                                    </MenuItem>
                                  ))}
                              </TextField>
                              <p className="errorForm" id="estadoP"></p>
                            </div>
                          )}

                          {mustraMunicipio && (
                            <div className="form-group" id="select">
                              <TextField
                                select
                                style={{ appearance: "auto" }}
                                id="municipio"
                                name="municipio"
                                data-value=""
                                label="Selecciona una ciudad para buscar una Escuela de procedencia"
                                className="form-control"
                                aria-required="true"
                                onChange={handleChangeEsc}
                              >
                                {municipios &&
                                  municipios.map(({ id, name }) => (
                                    <MenuItem
                                      value={JSON.stringify({
                                        nombre: name,
                                        key: id,
                                      })}
                                    >
                                      {name}
                                    </MenuItem>
                                  ))}
                              </TextField>
                              <p className="errorForm" id="municipioP"></p>
                            </div>
                          )}

                          {mustraEscuela && (
                            <div className="form-group" id="select">
                              <TextField
                                select
                                style={{ appearance: "auto" }}
                                id="escuelas"
                                name="escuelas"
                                data-value=""
                                className="form-control"
                                label="Selecciona una Escuela de procedencia"
                                aria-required="true"
                                onChange={handleChangeEsc}
                              >
                                {escuelas &&
                                  escuelas.map(({ clave, name }) => (
                                    <MenuItem
                                      value={JSON.stringify({
                                        nombre: name,
                                        key: clave,
                                      })}
                                    >
                                      {name}
                                    </MenuItem>
                                  ))}

                                <MenuItem
                                  key="otro"
                                  value={JSON.stringify({
                                    nombre: "otro",
                                    key: "otro",
                                  })}
                                >
                                  Otra (ingresa el nombre de la escuela en el
                                  siguiente campo)
                                </MenuItem>
                              </TextField>
                              <p className="errorForm" id="escuelaP"></p>
                            </div>
                          )}

                          {mustraCampoEscuela && (
                            <div className="form-group" id="select">
                              <TextField
                                variant="standard"
                                type="text"
                                label="Ingresa el nombre de la escuela"
                                className="form-control"
                                id="escuela"
                                name="escuela"
                                onChange={handleChangeEsc}
                              />
                              <p className="errorForm" id="escuelaIP"></p>
                            </div>
                          )}
                        </div>
                      )}


                      {infoPadre && (
                        <div className="form-group">
                          <br></br>
                          <h6>INFORMACIÓN DEL RESPONSABLE LEGAL DEL ESTUDIANTE</h6>
                          {/* LABEL: */}
                          <div className="preg">
                            <TextField
                              disabled={formularioNoDisponible}
                              type="text"
                              error={false}
                              helperText=""
                              label="Nombre(s)"
                              className="form-control effect-10"
                              id="nombre"
                              name="nombreP"
                              variant="standard"
                              onChange={handleChange}
                            />
                            <span class="focus-bg"></span>
                            <p className="errorForm" id="nombrePP"></p>
                          </div>

                          <div className="preg">
                            <TextField
                              disabled={formularioNoDisponible}
                              type="text"
                              label="Primer apellido"
                              className="form-control"
                              id="apellidoPaterno"
                              name="apellidoPaternoP"
                              variant="standard"
                              onChange={handleChange}
                            />
                            <p className="errorForm" id="apellidoPaternoPP"></p>
                          </div>

                          <div className="preg">
                            <TextField
                              disabled={formularioNoDisponible}
                              type="text"
                              label="Segundo apellido (opcional)"
                              className="form-control"
                              id="apellidoMaternoP"
                              name="apellidoMaternoP"
                              variant="standard"
                              onChange={handleChange}
                            />
                            <p className="errorForm" id="apellidoMaternoPP"></p>
                          </div>

                          <div className="preg">
                            <label htmlFor="telefono">
                              Celular del responsable legal
                            </label>
                            <PhoneInput
                              disabled={formularioNoDisponible}
                              inputProps={{
                                name: "telefonoP",
                                required: true,
                              }}
                              inputExtraProps={{
                                className: "form-control", // Agrega tu clase personalizada aquí
                              }}
                              inputStyle={{
                                border: "none",
                                borderBottom: "1px solid #949494",
                                width: "100%",
                                borderRadius: "0px",
                              }}
                              country={"mx"}
                              value={phoneNumberP}
                              onChange={handlePhoneChangeP}
                              placeholder="Celular del responsable legal"
                            />
                            <p className="errorForm" id="telefonoPP"></p>
                          </div>

                          <div className="preg">
                            <TextField
                              disabled={formularioNoDisponible}
                              type="text"
                              label="Correo electrónico del responsable legal"
                              className="form-control effect-10"
                              name="emailP"
                              variant="standard"
                              id="correoP"
                              onChange={handleChange}
                            />
                            <p className="errorForm" id="emailPP"></p>
                          </div>
                        </div>
                      )}
                      <br>
                      </br>
                      <h6>INFORMACIÓN DE INTERÉS ACADÉMICO</h6><br></br>
                      <div className="form-group" id="select">
                        <TextField
                          style={{ appearance: "auto" }}
                          disabled={formularioNoDisponible}
                          id="horario"
                          select
                          name="horario"
                          label="Horario para ser contactado por nuestros asesores"
                          data-value=""
                          className="form-control"
                          aria-required="true"
                          onChange={handleChange}
                        >
                          {horarios &&
                            horarios.map(({ id, value, name }) => (
                              <MenuItem
                                key={id}
                                value={JSON.stringify({
                                  nombre: value,
                                  key: id,
                                })}
                              >
                                {name}
                              </MenuItem>
                            ))}
                        </TextField>

                        <label htmlFor="horario">
                          {TextoHorario}
                        </label>
                        <p className="errorForm" id="horarioP"></p>
                      </div>
                      <br></br>
                      {/*====================================================SELECTS=========================================================== */}
                      <div
                        className="form-group"
                        id="select"
                        style={{ display: "none" }}
                      >
                        <TextField
                          style={{ appearance: "auto" }}
                          id="campus"
                          select
                          name="campus"
                          label="Selecciona un campus de interés"
                          data-value=""
                          className="form-control"
                          aria-required="true"
                          onChange={handleChange}
                        >
                          <option key="" value="">
                            Selecciona un campus de interés
                          </option>
                          {campus &&
                            campus.map(({ info }) => (
                              <MenuItem
                                id={info.clave}
                                key={info.clave}
                                value={JSON.stringify({
                                  nombre: info.texto,
                                  key: info.clave,
                                })}
                              >
                                {info.texto}
                              </MenuItem>
                            ))}
                        </TextField>
                        <p className="errorForm" id="campusP"></p>
                      </div>

                      <div className="form-group" id="select">
                        <TextField
                          style={{ appearance: "auto" }}
                          select
                          id="periodo"
                          name="periodo"
                          label="Fecha esperada de ingreso"
                          data-value=""
                          className="form-control"
                          aria-required="true"
                          onChange={handleChange}
                          disabled={formularioNoDisponible}
                        >
                          {periodos &&
                            periodos.map(
                              ({ period }) =>
                                period.soadKey !== "otro" && (
                                  <MenuItem
                                    key={period.soadKey}
                                    value={JSON.stringify({
                                      periodo: period.name,
                                      key: period.soadKey,
                                      oferta: period.offeringMightBeOutdated,
                                    })}
                                  >
                                    {period.name}
                                  </MenuItem>
                                )
                            )}
                        </TextField>
                        {mensajeShow && (
                          <div style={{ fontSize: 'small', color: 'darkgray' }}>{mensaje}</div>
                        )}
                        <p className="errorForm" id="periodoP"></p>
                      </div>


                      {mustraSelects && (
                        <>
                          {mustraArea && (
                            <>
                              <div className="form-group" id="select">
                                <TextField
                                  select
                                  style={{ appearance: "auto" }}
                                  id="area"
                                  name="area"
                                  data-value=""
                                  label="Selecciona una entrada de interés"
                                  className="form-control"
                                  aria-required="true"
                                  onChange={handleChange}
                                >
                                  {areaInteres &&
                                    areaInteres.map(({ id, name, soadKey }) => (
                                      <MenuItem
                                        key={soadKey}
                                        value={JSON.stringify({
                                          nombre: name,
                                          key: soadKey,
                                        })}
                                      >
                                        {name}
                                      </MenuItem>
                                    ))}
                                </TextField>
                                <p className="errorForm" id="areaP"></p>
                              </div>
                            </>
                          )}

                          {mustraPrograma && (
                            <>
                              <div className="form-group" id="select">
                                <TextField
                                  style={{ appearance: "auto" }}
                                  id="programa"
                                  select
                                  name="programa"
                                  label="Selecciona un programa de interés"
                                  data-value=""
                                  className="form-control"
                                  aria-required="true"
                                  onChange={handleChange}
                                >
                                  {programaInteres &&
                                    programaInteres.map(({ id, name, soadKey }) => (
                                      <MenuItem
                                        key={soadKey}
                                        value={JSON.stringify({
                                          nombre: name,
                                          key: soadKey,
                                        })}
                                      >
                                        {name}
                                      </MenuItem>
                                    ))}
                                </TextField>
                                <p className="errorForm" id="programaP"></p>
                              </div>
                            </>
                          )}
                        </>
                      )}


                      {/*======================================================================================================================================= */}


                      <div className="form-group" id="select">
                        <label className="checkbox-inline" htmlFor="avisos">
                          <input
                            disabled={formularioNoDisponible}
                            type="checkbox"
                            id="avisos"
                            name="avisos"
                            onChange={handleChangeAviso}
                          />{" "}
                          He leído y acepto los términos y condiciones del{" "}
                          <a
                            href="https://tec.mx/es/aviso-de-privacidad-prospectos"
                            target="blank_"
                            rel="noopener"
                          >
                            <b>AVISO DE PRIVACIDAD</b>
                          </a>{" "}
                          del Tecnológico de Monterrey.
                        </label>
                        <p className="errorForm" id="avisosP"></p>
                      </div>



                      <br />
                      <br />
                      <Grid container spacing={8}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={9}>
                          <input
                            id="btnSend"
                            className={`btnreg sendBottom ${isBotonBloqueado ? "bloqueado" : ""
                              }`}
                            type="submit"
                            value={isBotonBloqueado ? "Enviando..." : "REGÍSTRATE"}
                            disabled={isBotonBloqueado}
                            hidden={isBotonBloqueado}
                          />
                        </Grid>
                        <Grid item xs={1}></Grid>
                      </Grid>

                    </div>
                  )}

                </form>
              )}
            </div>
          </div>

          {!showForm && (
            <button
              className="titreg"
              onClick={handleButtonClick}
              style={{ marginBottom: "2%" }}
            >
              Regístrate Aquí
            </button>
          )}



        </div>
      </Grid>
    </>
  );
}

export { Form };
